import { createSlice } from "@reduxjs/toolkit";
import { userLoginThunk } from "./thunk";

const initialState = {
  user: JSON.parse(localStorage.getItem("user")) || null,
  error: null,
  isLoginSuccess: false,
  isLoading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isLoginSuccess = false;
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
    },
    resetFlags: (state) => {
      state.isLoginSuccess = false;
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLoginThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.isLoginSuccess = false;
      })
      .addCase(userLoginThunk.fulfilled, (state, action) => {
        state.user = action.payload;
        state.isLoginSuccess = true;
        state.isLoading = false;
      })
      .addCase(userLoginThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = typeof action.payload === "string" ? action.payload : "Something went wrong";
      });
  },
});

// ✅ Export both actions
export const { logout, resetFlags } = authSlice.actions;

export default authSlice.reducer;
